import axios from "axios";

export function getDashboard(co) {
    const config = {
        params: co,
    };
    return axios.get(process.env.VUE_APP_API_URL + "Dashboard/dashboard", config);
}

export function setKvkk(kvkkid) {
    // MIGRATION: Using Local API instead of SSO
    // Note: The backend endpoint is now in AuthController for simplicity
    return axios.get(process.env.VUE_APP_API_URL + "Auth/setKvkkOnay/" + kvkkid)
}